import { Entity } from 'engine/Entity';
import { UIFacet } from 'engine/facets/UIFacet';
import { create } from 'engine/lib/create';
import { BotState } from 'game/state/BotState';
import { EditBot } from './EditBot';

interface MainWorldUIProps {
  bot: Entity<{ state: BotState }> | null,
  onExitEditBot: () => void,
}

export class MainWorldUI extends Entity<MainWorldUIProps> {
  createFacets(props: MainWorldUIProps) {
    return [
      create(UIFacet, {
        Component: () => props.bot && <EditBot bot={props.bot} onClose={props.onExitEditBot} />,
      }),
    ];
  }
}
